import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { QuickSkeleton } from "~/areas/tasks/components/Task/Kubernetes/components/QuickSkeleton";
const styles = {
    container: css({
        display: "flex",
        flexDirection: "column",
        gap: space[16],
    }),
    navItem: css({
        display: "flex",
        flexDirection: "row",
        gap: space[4],
    }),
    navItemIcon: css({
        height: "20px",
        width: "20px",
    }),
    navItemTitle: css({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flexGrow: 1,
        "> div": {
            height: "20px",
            marginBottom: space[8],
        },
    }),
};
export const ManifestNavigationTreeLoadingSkeleton = () => (<div className={styles.container}>
        {[...new Array(3)].map((x, i) => (<div key={`navItem-${i}`} className={styles.navItem}>
                <div className={styles.navItemIcon}>
                    <QuickSkeleton />
                </div>
                <div className={styles.navItemTitle}>
                    <QuickSkeleton />
                    <QuickSkeleton />
                </div>
            </div>))}
    </div>);
